import { fetchResource } from 'api-provider/actions';
import { BackendRpErrorResponse } from './BackendRpErrorResponse';

/**
 * Wrapper around fetchResource specifically for Recurring Payments API
 * Automatically adds preserveErrorObject and skipErrorDisplay options
 * Errors are already parsed to BackendRpErrorResponse format by the backend
 * 
 * @param {Function|Object} resourceCreator - Resource creator function or resource object
 * @param {Object} payload - Payload to pass to resource creator
 * @param {Object} api - API configuration object
 * @returns {FetchResult} FetchResult with errors already in BackendRpErrorResponse format
 */
export const fetchResourceRP = (resourceCreator, payload, api) => {
  // Get the resource first
  const isFunction = typeof resourceCreator === 'function';
  const baseResource = isFunction ? resourceCreator(payload) : resourceCreator;
  
  // Enhance resource with RP-specific options
  const enhancedResource = {
    ...baseResource,
    preserveErrorObject: true,
    skipErrorDisplay: true,
  };

  // Call fetchResource with enhanced resource
  const fetchResult = fetchResource(enhancedResource, payload, api);

  // Wrap the promise to convert errors to BackendRpErrorResponse format
  // The backend already returns errors in BackendRpErrorResponse format (snake_case)
  const wrappedPromise = fetchResult.promise.catch((error) => {

    const errorDefault = {
      status_code: error?.response?.status || error?.status || 500,
      message: error?.response?.data?.message || error?.message || 'An error occurred',
      message_code: error?.response?.data?.message_code || error?.message_code || 'UNKNOWN_ERROR',
      validations: error?.response?.data?.validations || [],
    };

    throw new BackendRpErrorResponse(error?.response?.data || errorDefault);
  });

  return wrappedPromise;
};
